module.exports = {
  "order": {
    "taxonomy": [
      "dwc:scientificName",
      "dwc:higherClassification",
      "dwc:kingdom",
      "dwc:phylum",
      "dwc:class",
      "dwc:order",
      "dwc:family",
      "idigbio:subfamily",
      "idigbio:tribe",
      "dwc:genus",
      "dwc:specificEpithet",
      "dwc:infraspecificEpithet",
      "dwc:scientificNameAuthorship",
      "dwc:taxonRank",
      "dwc:nomenclaturalStatus",
      "dwc:nomenclaturalCode",
      "dwc:vernacularName",
      "dwc:taxonRemarks"
    ],
    "specimen": [
      "dwc:associatedOccurrences",
      "dwc:typeStatus",
      "dwc:identifiedBy",
      "dwc:dateIdentified",
      "dwc:previousIdentifications",
      "dwc:identificationQualifier",
      "dwc:identificationRemarks",
      "dwc:identificationReferences",
      "dwc:catalogNumber",
      "dwc:otherCatalogNumbers",
      "idigbio:barcodeValue",
      "dwc:preparations",
      "dwc:individualCount",
      "dwc:lifeStage",
      "dwc:sex",
      "dwc:reproductiveCondition",
      "dwc:behavior",
      "idigbio:verbatimHost",
      "dwc:institutionCode",
      "dwc:collectionCode",
      "dwc:occurrenceID",
      "dwc:datasetName",
      "dwc:basisOfRecord",
      "dcterms:type",
      "dwc:associatedMedia",
      "dwc:associatedReferences",
      "dwc:associatedOccurences",
      "dwc:associatedSequences",
      "dwc:associatedTaxa"
    ],
    "collectionevent": [
      "dwc:recordedBy",
      "dwc:recordedByID",
      "dwc:recordNumber",
      "dwc:fieldNumber",
      "dwc:eventDate",
      "dwc:verbatimEventDate",
      "dwc:year",
      "dwc:month",
      "dwc:day",
      "dwc:startDayOfYear",
      "dwc:endDayOfYear",
      "dwc:samplingProtocol",
      "dwc:fieldNotes",
      "dwc:occurrenceRemarks"
    ],
    "locality": [
      "dwc:country",
      "dwc:countryCode",
      "dwc:stateProvince",
      "dwc:county",
      "dwc:municipality",
      "dwc:higherGeography",
      "dwc:continent",
      "idigbio:drainageBasin",
      "dwc:waterBody",
      "idigbio:stream",
      "dwc:islandGroup",
      "dwc:island",
      "dwc:locality",
      "dwc:verbatimLocality",
      "idigbio:locationtrs",
      "dwc:habitat",
      "dwc:decimalLatitude",
      "dwc:decimalLongitude",
      "dwc:verbatimLatitude",
      "dwc:verbatimLongitude",
      "dwc:coordinatePrecision",
      "dwc:maximumDepthInMeters",
      "dwc:minimumDepthInMeters",
      "dwc:maximumElevationInMeters",
      "dwc:minimumElevationInMeters",
      "dwc:verbatimElevation",
      "dwc:georeferenceProtocol",
      "dwc:locationRemarks",
      "dwc:locationID",
      "dwc:verbatimCoordinates",
      "inhs:location_Basin",
      "inhs:location_Stream",
      "dwc:locationAccordingTo",
      "dwc:coordinateUncertaintyInMeters",
      "dwc:geodeticDatum",
      "dwc:georeferenceRemarks",
      "dwc:georeferencedBy",
      "dwc:georeferencedDate"
    ],
    "paleocontext": [
      "dwc:bed",
      "dwc:group",
      "dwc:member",
      "dwc:formation",
      "dwc:earliestEraOrLowestErathem",
      "dwc:latestEraOrHighestErathem",
      "dwc:earliestEonOrLowestEonothem",
      "dwc:latestEonOrHighestEonothem",
      "dwc:earliestPeriodOrLowestSystem",
      "dwc:latestPeriodOrHighestSystem",
      "dwc:earliestEpochOrLowestSeries",
      "dwc:latestEpochOrHighestSeries",
      "dwc:earliestAgeOrLowestStage",
      "dwc:latestAgeOrHighestStage",
      "dwc:lowestBiostratigraphicZone",
      "dwc:lithostratigraphicTerms"
    ],
    "idhistory": [
      "dwc:Identification"
    ],
    "associatedtaxa": [
      "aec:associatedTaxa"
    ],
    "resourcerelationship": [
      "dwc:ResourceRelationship"
    ],
    "extendedmeasurementorfact": [
        "obis:ExtendedMeasurementOrFact"
    ],
    "materialsample": [
      "ggbn:MaterialSample"
    ],
    "chronometricage": [
      "chrono:ChronometricAge"
    ],
    "other": [
      "dcterms:references",
      "dcterms:language",
      "dcterms:modified",
      "id"
    ],
    "media": [
      "ac:associatedSpecimenReference",
      "ac:attributionLogoUrl",
      "ac:bestQualityAccessURI",
      "ac:bestQualityFurtherInformationUrl",
      "ac:captureDevice",
      "ac:mediumQualityAccessURI",
      "ac:providerId",
      "ac:providerManagedId",
      "ac:resourceCreationTechnique",
      "ac:subjectOrientation",
      "ac:subjectPart",
      "ac:tag",
      "ac:thumbnailAccessURI",
      "dcterms:available",
      "dcterms:bestQualityExtent",
      "dcterms:bestQualityFormat",
      "dcterms:creator",
      "dcterms:description",
      "dcterms:identifier",
      "dcterms:mediumQualityFormat",
      "dcterms:metadataCreator",
      "dcterms:metadataLanguage",
      "dcterms:metadataProvider",
      "dcterms:modified",
      "dcterms:provider",
      "dcterms:rights",
      "dcterms:thumbnailFormat",
      "dcterms:title",
      "dcterms:type",
      "dwc:nameAccordingTo",
      "xmprights:owner",
      "dc:type",
      "dc:rights",
      "ac:subtypeLiteral",
      "ac:subtype",
      "xmp:MetadataDate",
      "metadataLanguageLiteral",
      "metadataLanguage",
      "ac:providerManagedID",
      "xmp:Rating",
      "ac:commenter",
      "ac:commenterLiteral",
      "ac:comments",
      "ac:reviewer",
      "ac:reviewerLiteral",
      "ac:reviewerComments",
      "ac:hasServiceAccessPoint",
      "xmpRights:Owner",
      "xmpRights:UsageTerms",
      "xmpRights:WebStatement",
      "ac:licenseLogoURL",
      "photoshop:Credit",
      "ac:attributionLogoURL",
      "ac:attributionLinkURL",
      "ac:fundingAttribution",
      "dc:source",
      "dcterms:source",
      "dc:creator",
      "ac:providerLiteral",
      "ac:provider",
      "place:holder",
      "ac:metadataProviderLiteral",
      "ac:metadataProvider",
      "ac:metadataCreatorLiteral",
      "ac:metadataCreator",
      "ac:caption",
      "dc:language",
      "dcterms:language",
      "ac:physicalSetting",
      "Iptc4xmpExt:CVterm",
      "ac:subjectCategoryVocabulary",
      "Iptc4xmpExt:LocationShown",
      "Iptc4xmpExt:WorldRegion",
      "Iptc4xmpExt:CountryCode",
      "Iptc4xmpExt:CountryName",
      "Iptc4xmpExt:ProvinceState",
      "Iptc4xmpExt:City",
      "Iptc4xmpExt:Sublocation",
      "dcterms:temporal",
      "xmp:CreateDate",
      "ac:timeOfDay",
      "ac:taxonCoverage",
      "ac:otherScientificName",
      "ac:taxonCount",
      "Iptc4xmpExt:LocationCreated",
      "ac:digitizationDate",
      "ac:IDofContainingCollection",
      "ac:relatedResourceID",
      "ac:providerID",
      "ac:derivedFrom",
      "ac:associatedObservationReference",
      "ac:accessURI",
      "dc:format",
      "dcterms:format",
      "ac:variant",
      "dcterms:extent",
      "ac:furtherInformationURL",
      "ac:licensingException",
      "ac:serviceExpectation",
      "ac:variantDescription",
      "ac:hashFunction",
      "ac:hashValue",
      "mix:imageWidth",
      "mix:imageHeight",
      "mix:fileSize"
    ],
    "person": [
      "foaf:name",
      "idigbio:institutionType",
      "idigbio:institutionName",
      "idigbio:collectionCategory",
      "idigbio:collectionSize",
      "idigbio:importantHoldings"
    ]
  },
  "names": {
    "taxonomy": "Taxonomy",
    "dwc:scientificName": "Scientific Name",
    "dwc:higherClassification": "Higher Classfication",
    "dwc:kingdom": "Kingdom",
    "dwc:phylum": "Phylum",
    "dwc:class": "Class",
    "dwc:order": "Order",
    "dwc:family": "Family",
    "idigbio:subfamily": "Subfamily",
    "idigbio:tribe": "Tribe",
    "dwc:genus": "Genus",
    "dwc:specificEpithet": "Specific Epithet",
    "dwc:infraspecificEpithet": "Infraspecific Epithet",
    "dwc:scientificNameAuthorship": "Scientific Name Authors",
    "dwc:taxonRank": "Taxon Rank",
    "dwc:nomenclaturalStatus": "Nomenclatural Status",
    "dwc:nomenclaturalCode": "Nomenclatural Code",
    "dwc:vernacularName": "Vernacular Name",
    "dwc:taxonRemarks": "Taxon Remarks",
    "specimen": "Specimen",
    "dwc:typeStatus": "Type Status",
    "dwc:identifiedBy": "Identified By",
    "dwc:dateIdentified": "Date Identified",
    "dwc:previousIdentifications": "Previous Identifications",
    "dwc:identificationQualifier": "Identification Qualifier",
    "dwc:identificationRemarks": "Identification Remarks",
    "dwc:identificationReferences": "Identification References",
    "dwc:catalogNumber": "Catalog Number",
    "dwc:otherCatalogNumbers": "Other Catalog Numbers",
    "idigbio:barcodeValue": "Barcode",
    "dwc:preparations": "Preparations",
    "dwc:individualCount": "Individual Count",
    "dwc:lifeStage": "Life Stage",
    "dwc:sex": "Sex",
    "dwc:reproductiveCondition": "Reproductive Condition",
    "dwc:behavior": "Behavior",
    "idigbio:verbatimHost": "Verbatim Host",
    "dwc:institutionCode": "Institution Code",
    "dwc:collectionCode": "Collection Code",
    "dwc:occurrenceID": "Occurrence ID",
    "dwc:datasetName": "Dataset Name",
    "dwc:basisOfRecord": "Basis of Record",
    "dcterms:type": "Type of Resource",
    "dwc:associatedMedia": "Associated Media",
    "dwc:associatedReferences": "Associated References",
    "dwc:associatedOccurences": "Associated Occurrences",
    "dwc:associatedSequences": "Associated Sequences",
    "dwc:associatedTaxa": "Associated Taxa",
    "collectionevent": "Collection Event",
    "dwc:recordedBy": "Collected By",
    "dwc:recordedByID": "Collected By ID",
    "dwc:recordNumber": "Collector Number",
    "dwc:fieldNumber": "Field Number",
    "dwc:eventDate": "Date Collected",
    "dwc:verbatimEventDate": "Verbatim Date Collected",
    "dwc:year": "Year",
    "dwc:month": "Month",
    "dwc:day": "Day",
    "dwc:startDayOfYear": "Start Day of Year",
    "dwc:endDayOfYear": "End Day of Year",
    "dwc:samplingProtocol": "Sampling Protocol",
    "dwc:fieldNotes": "Field Notes",
    "dwc:occurrenceRemarks": "Collection Remarks",
    "locality": "Locality",
    "dwc:country": "Country",
    "dwc:countryCode": "Country Code",
    "dwc:stateProvince": "State / Province",
    "dwc:county": "County",
    "dwc:municipality": "Municipality",
    "dwc:higherGeography": "Higher Geography",
    "dwc:continent": "Continent",
    "idigbio:drainageBasin": "Drainage / Basin",
    "dwc:waterBody": "Water Body",
    "idigbio:stream": "Stream",
    "dwc:islandGroup": "Island Group",
    "dwc:island": "Island",
    "dwc:locality": "Locality",
    "dwc:verbatimLocality": "Verbatim Locality",
    "idigbio:locationtrs": "TRS",
    "dwc:habitat": "Habitat",
    "dwc:decimalLatitude": "Decimal Latitude",
    "dwc:decimalLongitude": "Decimal Longitude",
    "dwc:verbatimLatitude": "Verbatim Latitude",
    "dwc:verbatimLongitude": "Verbatim Longitude",
    "dwc:coordinatePrecision": "Coordinate Precision",
    "dwc:maximumDepthInMeters": "Maximum Depth in Meters",
    "dwc:minimumDepthInMeters": "Minimum Depth in Meters",
    "dwc:maximumElevationInMeters": "Maximum Elevation in Meters",
    "dwc:minimumElevationInMeters": "Minimum Elevation in Meters",
    "dwc:verbatimElevation": "Verbatim Elevation",
    "dwc:georeferenceProtocol": "Georeference Protocol",
    "dwc:locationRemarks": "Location Remarks",
    "dwc:locationID": "Location ID",
    "dwc:verbatimCoordinates": "Verbatim Coordinates",
    "inhs:location_Basin": "Basin",
    "inhs:location_Stream": "Stream",
    "dwc:locationAccordingTo": "Location According To",
    "dwc:coordinateUncertaintyInMeters": "Coordinate Uncertainty In Meters",
    "dwc:geodeticDatum": "Geodetic Datum",
    "dwc:georeferenceRemarks": "Georeference Remarks",
    "dwc:georeferencedBy": "Georeferenced By",
    "dwc:georeferencedDate": "Georeferenced Date",
    "paleocontext": "Paleo Context",
    "dwc:bed": "Bed",
    "dwc:group": "Geological Context Group",
    "dwc:member": "Member",
    "dwc:formation": "Formation",
    "dwc:earliestEraOrLowestErathem": "Earliest Era Or Lowest Erathem",
    "dwc:latestEraOrHighestErathem": "Latest Era Or Highest Erathem",
    "dwc:earliestEonOrLowestEonothem": "Earliest Eon Or Lowest Eonothem",
    "dwc:latestEonOrHighestEonothem": "Latest Eon Or Highest Eonothem",
    "dwc:earliestPeriodOrLowestSystem": "Earliest Period Or Lowest System",
    "dwc:latestPeriodOrHighestSystem": "Latest Period Or Highest System",
    "dwc:earliestEpochOrLowestSeries": "Earliest Epoch Or Lowest Series",
    "dwc:latestEpochOrHighestSeries": "Latest Epoch Or Highest Series",
    "dwc:earliestAgeOrLowestStage": "Earliest Age Or Lowest Stage",
    "dwc:latestAgeOrHighestStage": "Latest Age Or Highest Stage",
    "dwc:lowestBiostratigraphicZone": "Lowest Biostratigraphic Zone",
    "dwc:lithostratigraphicTerms": "Lithostratigraphic Terms",
    "other": "Other",
    "dcterms:language": "Language",
    "dcterms:modified": "Modified",
    "id": "ID",
    "media": "Media",
    "ac:associatedSpecimenReference": "Associated Specimen Reference",
    "ac:attributionLogoUrl": "Attribution Logo URL",
    "ac:bestQualityAccessURI": "Best Quality Access URI",
    "ac:bestQualityFurtherInformationUrl": "Best Quality Further Information URL",
    "ac:captureDevice": "Capture Device",
    "ac:mediumQualityAccessURI": "Medium Quality Access URI",
    "ac:providerId": "Provider ID",
    "ac:providerManagedId": "Provider Managed ID",
    "ac:resourceCreationTechnique": "Resource Creation Technique",
    "ac:subjectOrientation": "Subject Orientation",
    "ac:subjectPart": "Subject Part",
    "ac:tag": "Tag",
    "ac:thumbnailAccessURI": "Thumbnail Access URI",
    "dcterms:available": "Available",
    "dcterms:bestQualityExtent": "Best Quality Extent",
    "dcterms:bestQualityFormat": "Best Quality Format",
    "dcterms:creator": "Creator",
    "dcterms:description": "Description",
    "dcterms:identifier": "Identifier",
    "dcterms:mediumQualityFormat": "Medium Quality Format",
    "dcterms:metadataCreator": "Metadata Creator",
    "dcterms:metadataLanguage": "Metadata Language",
    "dcterms:metadataProvider": "Metadata Provider",
    "dcterms:provider": "Provider",
    "dcterms:rights": "Rights",
    "dcterms:thumbnailFormat": "Thumbnail Format",
    "dcterms:title": "Title",
    "dwc:nameAccordingTo": "Name According To",
    "xmprights:owner": "Rights Owner",
    "dc:type": "Type",
    "dc:rights": "Rights",
    "ac:subtypeLiteral": "Subtype",
    "ac:subtype": "Subtype",
    "xmp:MetadataDate": "Metadata Date",
    "metadataLanguageLiteral": "Metadata Language",
    "metadataLanguage": "Metadata Language",
    "ac:providerManagedID": "Provider-managed ID",
    "xmp:Rating": "Rating",
    "ac:commenter": "Commenter",
    "ac:commenterLiteral": "Commenter",
    "ac:comments": "Comments",
    "ac:reviewer": "Reviewer",
    "ac:reviewerLiteral": "Reviewer",
    "ac:reviewerComments": "Reviewer Comments",
    "ac:hasServiceAccessPoint": "Service Access Point",
    "xmpRights:Owner": "Credit",
    "xmpRights:UsageTerms": "License Terms",
    "xmpRights:WebStatement": "License URL",
    "ac:licenseLogoURL": "License Logo URL",
    "photoshop:Credit": "Attribution Statement",
    "ac:attributionLogoURL": "Attribution URL",
    "ac:attributionLinkURL": "Attribution Link URL",
    "ac:fundingAttribution": "Funding",
    "dc:source": "Published Source",
    "dcterms:source": "Published Source",
    "dc:creator": "Creator",
    "ac:providerLiteral": "Provider",
    "ac:provider": "Provider",
    "place:holder": "Place Holder",
    "ac:metadataProviderLiteral": "Metadata Provider",
    "ac:metadataProvider": "Metadata Provider",
    "ac:metadataCreatorLiteral": "Metadata Creator",
    "ac:metadataCreator": "Metadata Creator",
    "ac:caption": "Caption",
    "dc:language": "Language",
    "ac:physicalSetting": "Physical Setting",
    "Iptc4xmpExt:CVterm": "Subject Category",
    "ac:subjectCategoryVocabulary": "Subject Category Vocabulary",
    "Iptc4xmpExt:LocationShown": "Location Shown",
    "Iptc4xmpExt:WorldRegion": "World Region",
    "Iptc4xmpExt:CountryCode": "Country Code",
    "Iptc4xmpExt:CountryName": "Country Name",
    "Iptc4xmpExt:ProvinceState": "Provinceor State",
    "Iptc4xmpExt:City": "Cityor Place Name",
    "Iptc4xmpExt:Sublocation": "Sublocation",
    "dcterms:temporal": "Temporal Coverage",
    "xmp:CreateDate": "Original Dateand Time",
    "ac:timeOfDay": "Timeof Day",
    "ac:taxonCoverage": "Taxon Coverage",
    "ac:otherScientificName": "Other Scientific Name",
    "ac:taxonCount": "Taxon Count",
    "Iptc4xmpExt:LocationCreated": "Location Created",
    "ac:digitizationDate": "Dateand Time Digitized",
    "ac:IDofContainingCollection": "ID Containing Collection",
    "ac:relatedResourceID": "Related Resource ID",
    "ac:providerID": "Provider ID",
    "ac:derivedFrom": "Derived From",
    "ac:associatedObservationReference": "Associated Observation Reference",
    "ac:accessURI": "Access URI",
    "dc:format": "Format",
    "dcterms:format": "Format",
    "ac:variant": "Variant",
    "dcterms:extent": "Extent",
    "ac:furtherInformationURL": "Further Information URL",
    "ac:licensingException": "Licensing Exception Statement",
    "ac:serviceExpectation": "Service Expectation",
    "ac:variantDescription": "Variant Description",
    "ac:hashFunction": "Hash Function",
    "ac:hashValue": "Hash",
    "mix:imageWidth": "Image Width",
    "mix:imageHeight": "Image Height",
    "mix:fileSize": "File Size",
    "person": "Person",
    "foaf:name": "Name",
    "idigbio:institutionType": "Institution Type",
    "idigbio:institutionName": "Institution Name",
    "idigbio:collectionCategory": "Collection Category",
    "idigbio:collectionSize": "Collection Size",
    "idigbio:importantHoldings": "Important Holdings",
    "dwc:associatedOccurrences": "Associated Occurrences",
    "dcterms:references": "References",

    "idhistory": "Identification History",
    "dwc:identificationID": "Identification ID",
    "dwc:verbatimIdentification": "Verbatim Identification",
    "dwc:identifiedByID": "Identified By (ID)",
    "dwc:identificationVerificationStatus": "Identification Verification Status",

    "associatedtaxa": "Associated Taxa",
    "aec:associatedAuthor": "Author",
    "aec:associatedCollectionLocation": "Collection Location",
    "aec:associatedCommonName": "Common Name",
    "aec:associatedCondition": "Condition",
    "aec:associatedDeterminedBy": "Determined By",
    "aec:associatedEmergenceVerbatimDate": "Emergence Verbatim Date",
    "aec:associatedFamily": "Family",
    "aec:associatedGenus": "Genus",
    "aec:associatedImageAccessURI": "Image Access URI",
    "aec:associatedImageCreator": "Image Creator",
    "aec:associatedImageRights": "Image Rights",
    "aec:associatedLocationOnHost": "Location on Host",
    "aec:associatedNotes": "Notes",
    "aec:associatedOccurrenceID": "Occurrence ID",
    "aec:associatedRelationshipTerm": "Relationship Term",
    "aec:associatedRelationshipURI": "Relationship URI",
    "aec:associatedScientificName": "Scientific Name",
    "aec:associatedSpecificEpithet": "Specific Epithet",
    "aec:isCultivar": "Is Cultivar?",

    "resourcerelationship": "Resource Relationship",
    "dwc:relatedResourceID": "Related Resource ID",
    "dwc:relationshipAccordingTo": "Relationship According To",
    "dwc:relationshipEstablishedDate": "Relationship Established Date",
    "dwc:relationshipOfResource": "Relationship of Resource",
    "dwc:relationshipOfResourceID": "Relationship of Resource ID",
    "dwc:relationshipRemarks": "Relationship Remarks",
    "dwc:resourceID": "Resource ID",
    "dwc:resourceRelationshipID": "Resource Relationship ID",

    "extendedmeasurementorfact": "Extended Measurement or Fact",
    "dwc:measurementDeterminedBy": "Measurement Determined By",
    "dwc:measurementDeterminedDate": "Measurement Determined Date",
    "dwc:measurementType": "Measurement Type",
    "dwc:measurementValue": "Measurement Value",
    "obis:measurementTypeID": "Measurement Type ID",
    "obis:measurementValueID": "Measurement Value ID",

    "materialsample": "Material Sample",
    "ggbn:concentrationUnit": "Concentration Unit",
    "ggbn:concentration": "Concentration",
    "ggbn:materialSampleType": "Material Sample Type",
    "ggbn:ratioOfAbsorbance260_230": "Ratio of Absorbance (260/230 nm)", //| For DNA samples only
    "ggbn:ratioOfAbsorbance260_280": "Ratio of Absorbance (260/280 nm)", //|
    "ggbn:sampleDesignation": "Sample Designation",

    "chronometricage": "Chronometric Age",
    "chrono:chronometricAgeReferences": "Chronometric Age References",
    "chrono:chronometricAgeRemarks": "Chronometric Age Remarks",
    "chrono:maximumChronometricAge": "Maximum Chronometric Age",
    "chrono:maximumChronometricAgeReferenceSystem": "Maximum Chronometric Age Reference System",
    "chrono:minimumChronometricAge": "Minimum Chronometric Age",
    "chrono:minimumChronometricAgeReferenceSystem": "Minimum Chronometric Age Reference System",
  }
}
